


































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

interface Select{
  isMenuActive:boolean
}
@Component
export default class UiSelectItem extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop()
  item: any;

  @Prop({default: 'text'})
  itemText: any;

  @Prop()
  multiple: boolean;

  @Prop()
  select: Select;

  get title() {
    return typeof this.item === 'string'
      ? this.item
      : this.item[this.itemText];
  }

  get hasPlanLimits() {
    return this.hasPlanLimitsRestriction(this.item.planLimits)
  }

  onClick(event) {
    if(this.item.click){
      this.item.click(event);
      event.stopPropagation()
    }
    if(this.hasPlanLimits){
      this.handleClickPlanLimits(this.item.planLimits)
      this.select.isMenuActive = false;
      event.stopPropagation()
    }
  }
}
